import { render, staticRenderFns } from "./DetailLevelComponent.vue?vue&type=template&id=66d0b0b2&scoped=true"
import script from "./DetailLevelComponent.vue?vue&type=script&lang=js"
export * from "./DetailLevelComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailLevelComponent.vue?vue&type=style&index=0&id=66d0b0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d0b0b2",
  null
  
)

export default component.exports